import React from "react";
import Link from "next/link";
import { Box } from "@mui/material";
import GridContainer from "@/components/Grid/GridContainer";
import GridItem from "@/components/Grid/GridItem";
import Button from "@/components/CustomButtons/Button";
import Footer from "@/components/Footer/Footer";
import styles from "@/styles/jss/nextjs-material-kit-pro/pages/componentsSections/footerStyle.js";
import { colors } from "@/theme/colors";
import { simpleForm as NewsletterForm } from "@/components/Importable/Newsletter";
import { useSiteSettings } from "@/context/SiteSettingsContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SectionFooter({
  sidebarOffset = 0,
  hideNewsletter = false,
  banner
}) {
  const {
    settings: siteSettings
  } = useSiteSettings();
  return /*#__PURE__*/_jsx(Footer, {
    banner: banner,
    theme: "white",
    "aria-label": "Site Footer",
    "data-select-target": "Footer",
    content: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("ul", {
        style: {
          ...styles.socialButtons,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "0.5rem",
          listStyle: "none",
          padding: 0,
          margin: 0
        },
        children: [siteSettings.footerConfig.social.x ? /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(Button, {
            justIcon: true,
            simple: true,
            href: "https://x.com/ProductCertSV",
            "aria-label": "Product Certification on X",
            color: "x",
            children: /*#__PURE__*/_jsx("i", {
              className: "fab fa-x-twitter",
              style: {
                color: "#000"
              }
            })
          })
        }) : null, siteSettings.footerConfig.social.youtube ? /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(Button, {
            justIcon: true,
            simple: true,
            href: "https://www.youtube.com/@ProductCertification",
            "aria-label": "Product Certification on YouTube",
            color: "youtube",
            children: /*#__PURE__*/_jsx("i", {
              className: "fab fa-youtube"
            })
          })
        }) : null]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          ...styles.footer,
          textAlign: "center",
          marginTop: "12px"
        },
        children: [/*#__PURE__*/_jsxs(GridContainer, {
          style: {
            maxWidth: hideNewsletter ? "none" : "1100px",
            margin: "0 auto",
            padding: 0,
            width: "100%"
          },
          sx: {
            display: "flex",
            flexDirection: {
              xs: "column",
              sm: "row"
            },
            gap: 2,
            alignItems: "start",
            justifyContent: hideNewsletter ? "space-evenly" : "center",
            ...(hideNewsletter ? {} : {
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr 1fr"
              },
              justifyItems: "center"
            })
          },
          children: [/*#__PURE__*/_jsxs(GridItem, {
            sx: {
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              alignItems: "center"
            },
            children: [/*#__PURE__*/_jsx("h5", {
              children: "ProductCertification.com LLC"
            }), /*#__PURE__*/_jsx("p", {
              children: siteSettings.footerConfig.text
            })]
          }), /*#__PURE__*/_jsxs(GridItem, {
            sx: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center"
            },
            children: [/*#__PURE__*/_jsx("h5", {
              children: "Browse"
            }), /*#__PURE__*/_jsxs(Box, {
              component: "ul",
              sx: {
                listStyle: "none",
                p: 0,
                m: 0,
                display: "flex",
                flexDirection: "column",
                gap: 0.5
              },
              children: [/*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/",
                  style: {
                    color: colors.gray.dark,
                    fontWeight: 600,
                    textDecoration: "none"
                  },
                  children: "Home"
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/organizations",
                  style: {
                    color: colors.orange.primary,
                    fontWeight: 600,
                    textDecoration: "none"
                  },
                  children: "Organizations"
                })
              }), siteSettings.eventsVisible ? /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/events",
                  style: {
                    color: colors.green.primary,
                    fontWeight: 600,
                    textDecoration: "none"
                  },
                  children: "Events"
                })
              }) : null, siteSettings.regulationsVisible ? /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/regulations",
                  style: {
                    color: colors.blue.primary,
                    fontWeight: 600,
                    textDecoration: "none"
                  },
                  children: "Regulations"
                })
              }) : null, siteSettings.articlesVisible ? /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/articles",
                  style: {
                    color: colors.purple.primary,
                    fontWeight: 600,
                    textDecoration: "none"
                  },
                  children: "Articles"
                })
              }) : null, siteSettings.professionalsVisible ? /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/professionals",
                  style: {
                    color: colors.rose.primary,
                    fontWeight: 600,
                    textDecoration: "none"
                  },
                  children: "Professionals"
                })
              }) : null]
            })]
          }), !hideNewsletter && siteSettings.footerConfig.formVisible && /*#__PURE__*/_jsxs(GridItem, {
            sx: {
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              alignItems: "center"
            },
            children: [/*#__PURE__*/_jsx("h5", {
              children: "Subscribe to Newsletter"
            }), /*#__PURE__*/_jsx(NewsletterForm, {
              source: "footer",
              description: "Stay up to date with any new regulatory briefs, articles, or events"
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          style: {
            ...styles.pullCenter,
            marginTop: "16px",
            textAlign: "center",
            width: "100%",
            fontSize: "0.75rem",
            color: "#9e9e9e"
          },
          children: "The content of this website is for general information purposes only and is not intended to convey legal or other professional advice."
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            ...styles.pullCenter,
            ...styles.copyRight,
            marginTop: "16px",
            textAlign: "center",
            width: "100%"
          },
          children: ["Copyright \xA9 ", new Date().getFullYear(), " ", "", /*#__PURE__*/_jsx(Link, {
            href: "/organizations",
            target: "_blank",
            style: {
              textDecoration: "none"
            },
            children: "ProductCertification.com LLC"
          }), " ", "All Rights Reserved."]
        })]
      })]
    }),
    style: {
      marginLeft: sidebarOffset ? `${sidebarOffset}px` : 0,
      transition: "margin-left 0.3s ease",
      borderTop: "none"
    }
  });
}